import React from 'react';
import {
  Modal,
  Text,
  BlockStack,
} from '@shopify/polaris';

const DeleteSceneModal = ({ 
  isOpen, 
  onClose, 
  onConfirm,
  isDeleting 
}) => {
  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      title="Confirm Deletion"
      primaryAction={{
        content: 'Delete',
        onAction: onConfirm,
        loading: isDeleting,
        destructive: true,
      }}
      secondaryActions={[
        {
          content: 'Cancel',
          onAction: onClose,
        },
      ]}
    >
      <BlockStack gap="400">
        <Text>Are you sure you want to delete this scene? This action cannot be undone.</Text>
      </BlockStack>
    </Modal>
  );
};

export default DeleteSceneModal;
